import BillOfMaterial from "../screens/ingredients/BillOfMaterial";
import IngredientList from "../screens/ingredients/ingredientList/IngredientList";
import IngredientListNew from "../screens/lcaIngredients/ingredientList/IngredientListNew";
import { adminAccess, supplierAccess, userAccess } from "./useRoleAccess";
import { DISABLE_BOM_CHEMICAL, ENABLE_LCA_INGREDIENT_UI_REDESIGN } from "../config/constants";

const IngredientGrid = ENABLE_LCA_INGREDIENT_UI_REDESIGN ? <IngredientListNew /> : <IngredientList />;

export const IngredientRoutes = [
  {
    path: "/ingredient",
    route: DISABLE_BOM_CHEMICAL ? IngredientGrid : <BillOfMaterial />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess, ...supplierAccess]
  }
];
